import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedOregonActivityType = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add an activity type"
    okText="ADD AN ACTIVITY TYPE"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose an activity type:"
      queryVariables={{ typeId: FILTER_TYPE.ACTIVITY_TYPE.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Activity type is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedOregonActivityType.Item = Item;

export default RelatedOregonActivityType;
